/**
 * Deals with side menu items labels
 */
export class SideMenuItems {
  /**
   * @constructor
   */
  constructor(
    // NOSONAR
    public controlPanel = ['control-panel', 'globe-2-outline'], // NOSONAR
    public home = ['activities-feed', 'grid-outline'], // NOSONAR
    public businessList = ['business-list', 'briefcase-outline'], // NOSONAR
    public addPoints = ['add-points', 'stars'], // NOSONAR
    public notifications = ['notifications', 'notifications'], // NOSONAR
    public support = ['support', 'sms'], // NOSONAR
    public rewards = ['rewards', 'gift-outline'], // NOSONAR
    public coupons = ['coupons', 'redeem'], // NOSONAR
    public pointBalance = ['point-balance', 'account_balance_wallet'], // NOSONAR
    public printersAndWarranty = ['warranties', 'shield-outline'], // NOSONAR
    public businessSettings = ['business-settings', 'domain'], // NOSONAR
    public accountSettings = ['account-settings', 'settings-2-outline'], // NOSONAR
    public systemSettings = ['system-settings', 'monitor-outline'], // NOSONAR
    public businessUnification = ['business-unification', 'collapse-outline'], // NOSONAR
    public faq = ['faq', 'help'], // NOSONAR
    public upload = ['upload', 'upload-outline'], // NOSONAR
    public downloadReports = ['download-reports', 'trending-up-outline'] // NOSONAR
  ) {}

  /**
   * Side menu items that always show on View Only Admin desktop
   */
  get viewOnlyFlatNavItems() {
    return [this.home, this.businessList, this.rewards, this.accountSettings];
  }

  /**
   * Side menu items that always show on Regional Admin desktop
   */
  get regionalFlatNavItems() {
    return [
      this.home,
      this.businessList,
      this.rewards,
      this.upload,
      this.accountSettings,
      this.businessUnification,
      this.printersAndWarranty,
      this.downloadReports,
    ];
  }

  /**
   * Side menu items that always show on Global Admin desktop
   */
  get globalFlatNavItems() {
    return [
      this.controlPanel,
      this.home,
      this.businessList,
      this.rewards,
      this.upload,
      this.accountSettings,
      this.systemSettings,
      this.businessUnification,
      this.printersAndWarranty,
      this.downloadReports,
    ];
  }
}
